import React, { Children } from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../../utils/breakpoint";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import { biggerScreenBreakpoint, biggerScreenLastRowStyles, borderWidthOnBiggerScreen, Cell } from "../common";
var StyledFooter = styled.div.withConfig({
  componentId: "sc-1ras581-0"
})(function (_ref) {
  var $activeColumnIndex = _ref.$activeColumnIndex,
    $numberOfColumns = _ref.$numberOfColumns;
  return css(["", ";display:block;margin-top:", ";> div{display:flex;grid-template-columns:repeat(", ",1fr);width:100%;min-height:", ";", "{> div:first-child{flex-flow:row;min-width:", ";}grid-column-gap:", ";grid-template-columns:", ";}}"], biggerScreenLastRowStyles($activeColumnIndex), unit(borderWidthOnBiggerScreen), $numberOfColumns, space(12), breakpoint(biggerScreenBreakpoint), space(50), unit(borderWidthOnBiggerScreen), $numberOfColumns === 1 ? "1fr 1fr" : "".concat(space(50), " repeat(").concat($numberOfColumns, ", 1fr)"));
});

/* eslint-disable react/no-array-index-key */
function Footer(_ref2) {
  var footer = _ref2.footer,
    numberOfColumns = _ref2.numberOfColumns,
    activeColumnIndex = _ref2.activeColumnIndex,
    rowAriaLabel = _ref2.rowAriaLabel,
    cellAriaLabel = _ref2.cellAriaLabel;
  return /*#__PURE__*/React.createElement(StyledFooter, {
    $activeColumnIndex: activeColumnIndex,
    $numberOfColumns: numberOfColumns,
    role: "row",
    "aria-label": rowAriaLabel
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Cell, {
    role: "cell",
    "aria-label": cellAriaLabel
  }), Children.map(footer, function (item, footerCellIndex) {
    return /*#__PURE__*/React.createElement(Cell, {
      key: footerCellIndex,
      role: "cell",
      "aria-label": cellAriaLabel
    }, item);
  })));
}
export default Footer;